import type { JSX } from 'react';

import type { ErrorHandlerProps } from 'src/app/pages/petitionEditV2/pageContext';

export function PetitionEditErrorHandler({ context: { error } }: ErrorHandlerProps): JSX.Element {
	throw new Error(`Failed to retrieve data for PetitionEdit page (error: ${error})`);
}
